import { createStore, applyMiddleware, compose } from "redux";
import { browserHistory } from "react-router";
import RootReducer from "../Reducer/RootReducer";
import { persistState } from "redux-devtools";
import { routerMiddleware } from "react-router-redux";
import * as createlogger from "redux-logger";
import createSagaMiddleware from "redux-saga";
import sagaMonitor from "../Saga/Monitor";
import rootSaga from "../Saga/Saga";
import Environment from "../Environment/Environment";

const loggerMiddleware = createlogger({
  level: "info",
  collapsed: true,
  logErrors: true,
  colors: {
    title: (): string => {
      return "#3366ff";
    },
    prevState: (): string => {
      return "#ccc";
    },
    action: (): string => {
      return "#3366ff";
    },
    nextState: (): string => {
      return "#cc3333";
    },
    error: (): string => {
      return "#ff0000";
    }
  }
});

const sagaMiddleware = createSagaMiddleware(sagaMonitor as any);

const storeConfigurator = (browserHistory, initialState = {}) => {
  const reduxRouterMiddleware = routerMiddleware(browserHistory);
  let middleware = applyMiddleware(sagaMiddleware);
  let enhancer;

  if (process.env.NODE_ENV !== "production") {

    const middlewares = [
      require("redux-immutable-state-invariant")(),
      sagaMiddleware
    ];

    // We don't want to show actions on production.
    if (Environment.isDevelopment()) {
      middlewares.push(loggerMiddleware);
    }

    middleware = applyMiddleware(...middlewares);

    const getDebugSessionKey = () => {
      const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
      return (matches && matches.length) ? matches[1] : null;
    };

    enhancer = compose(
      middleware,
      persistState(getDebugSessionKey()),
      (<any>window).devToolsExtension ? (<any>window).devToolsExtension() : f => f,
    );
  } else {
    enhancer = compose(
      middleware,
      (<any>window).devToolsExtension ? (<any>window).devToolsExtension() : f => f,
    );
  }

  const store = (createStore as any)(
    RootReducer,
    initialState,
    enhancer,
    reduxRouterMiddleware,
    sagaMiddleware,
    loggerMiddleware,
    createStore
  );

  sagaMiddleware.run(rootSaga);

  if ((module as any).hot) {
    (module as any).hot.accept(RootReducer, () => {
      const nextRootReducer = RootReducer;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export const Configurator = storeConfigurator(browserHistory);
